var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterest = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.861 41.861"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pinterest_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h41.861v41.861H0z",
  "data-name": "Rectangle 7496"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18860"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18708"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pinterest_svg__a)",
  "data-name": "Group 18707"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.841 22.7a.447.447 0 0 0 .65-.324c.06-.228.2-.8.265-1.043a.63.63 0 0 0-.187-.723 3.74 3.74 0 0 1-.856-2.546 6.15 6.15 0 0 1 6.387-6.219c3.486 0 5.4 2.13 5.4 4.976 0 3.743-1.657 6.9-4.116 6.9a2.01 2.01 0 0 1-2.049-2.5c.391-1.645 1.146-3.42 1.146-4.608a1.738 1.738 0 0 0-1.751-1.949c-1.388 0-2.5 1.437-2.5 3.361a5 5 0 0 0 .415 2.054l-1.67 7.074a14.5 14.5 0 0 0-.039 4.934.173.173 0 0 0 .308.075 13.9 13.9 0 0 0 2.344-4.249c.159-.578.914-3.568.914-3.568a3.72 3.72 0 0 0 3.17 1.617c4.175 0 7.006-3.8 7.006-8.9 0-3.851-3.262-7.437-8.219-7.437-6.168 0-9.279 4.422-9.279 8.11 0 2.233.846 4.219 2.659 4.959",
  "data-name": "Path 27250"
}))))));
export { SvgPinterest as ReactComponent };
export default __webpack_public_path__ + "static/media/pinterest.a17ce9456fc85ea47bb6ab8ceded9240.svg";